import { features } from '@/mocks/homeData';

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            为什么选择在线吃瓜
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            五大核心优势，为你打造最畅快的每日吃瓜体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((item, i) => (
            <div
              key={i}
              className="group p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 whitespace-nowrap">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}